// метод для плавного скрытия и показа страницы
const style = document.createElement("style");
style.textContent = `
  .history-page-fade {
    transition: opacity 0.5s ease-in-out !important;
  }
`;
document.head.appendChild(style);

window.fadeHistoryPage = function () {
  const element = document.querySelector(".history-page-fade");
  if (element) {
    element.style.opacity = "0";
  }
};

window.unfadeHistoryPage = function () {
  const element = document.querySelector(".history-page-fade");
  if (element) {
    element.style.opacity = "1";
  }
};
